<!--

	Shows a toaster notification containing an announcement when a parent logs in

-->

<template>
	<div>
		<Message :toast="toast" :portal="getPortalId()">
			<slot>
				<a :href="$tr('miaprepannouncement.link')">
					<span v-tr="'miaprepannouncement.linktext'" />
				</a>
				<span v-tr="'miaprepannouncement.linktextremainder'" />
			</slot>
		</Message>
		<Button :toast="toast" :portal="getPortalId('close')">
			<slot>
				<span v-tr="'miaprepannouncement.popup_close'" />
			</slot>
		</Button>
	</div>
</template>
<script lang='ts'>

import { Component, toNative } from "vue-facing-decorator";
import type { SnotifyToast, SnotifyToastConfig } from "vue3-snotify";
import { MiaPlaza } from "../../../Reinforced.Typings";
import Button from "./Shared/Button.vue";
import Message from "./Shared/Message.vue";
import { SNotification } from "./Shared/SNotification";

@Component({
	components: {
		Button,
		Message,
	},
})
export class MiaPrepAnnouncement extends SNotification<MiaPlaza.Control.Vue.Notifications.IMiaPrepAnnouncement> {
	protected getToastConstructor(): (config: SnotifyToastConfig) => SnotifyToast {
		return (config) => { return this.$snotify.info("…", config); };
	}

	protected getToastConfig(): SnotifyToastConfig {
		return {
			...this.getDefaultToastConfig(),
			buttons: [
				{
					// eslint-disable-next-line @typescript-eslint/unbound-method
					action: () => this.dismissOnServer().then(this.hide),
					text: this.getPortalId("close"),
				},
			],
		};
	}
}

export default toNative(MiaPrepAnnouncement);
</script>
